import { render, staticRenderFns } from "./homeAbout.vue?vue&type=template&id=a04346b0&scoped=true"
import script from "./homeAbout.vue?vue&type=script&lang=js"
export * from "./homeAbout.vue?vue&type=script&lang=js"
import style0 from "./homeAbout.vue?vue&type=style&index=0&id=a04346b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04346b0",
  null
  
)

export default component.exports